import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import type { WithBoundArgs } from '@glint/template';

import PrismRadioGroupInput from './radio-group/input.gts';

interface PrismRadioGroupSignature {
  Args: {
    disabled?: boolean;
    isHorizontal?: boolean;
    isSmall?: boolean;
    name: string;
    onChange: (event: Event) => void;
    value?: string;
  };
  Blocks: {
    default: [
      {
        input: WithBoundArgs<
          typeof PrismRadioGroupInput,
          | 'onChange'
          | 'name'
          | 'radioGroupDisabled'
          | 'checkedValue'
          | 'isSmall'
        >;
      },
    ];
  };
  Element: HTMLFieldSetElement;
}

const PrismRadioGroup = <template>
  <fieldset
    class="prism-radio-group
      {{if
        @isHorizontal
        'prism-radio-group--horizontal'
        'prism-radio-group--vertical'
      }}"
    ...attributes
  >
    {{yield
      (hash
        input=(component
          PrismRadioGroupInput
          checkedValue=@value
          isSmall=@isSmall
          name=@name
          onChange=@onChange
          radioGroupDisabled=@disabled
        )
      )
    }}
  </fieldset>
</template> satisfies TOC<PrismRadioGroupSignature>;

export default PrismRadioGroup;
